import { GoogleMap, Marker } from "@react-google-maps/api";
import React from "react";
import { useSelector } from "react-redux";
import { getOrderTypeText } from "../../../constants/constants";
import StarFIDIcon from "../../../images/StarFIDIcon.svg";
import { RestaurantCart } from "../../../interfaces/Catalogue";

interface RestaurantInfoProps {
  restaurantId: number;
  userLoyalityPoints: number;
  restaurantCart: RestaurantCart;
  showMarker: boolean;
  isMaintenantChecked: boolean;
  tempsPreparation: string | undefined;
}

const RestaurantInfo: React.FC<RestaurantInfoProps> = ({
  restaurantId,
  userLoyalityPoints = 0,
  restaurantCart,
  showMarker,
  isMaintenantChecked,
  tempsPreparation,
}) => {

  const location = useSelector((state: any) => state.auth.location);

  const center = {
    lat: location?.lat,
    lng: location?.lng,
  };

  const GoogleMapStyle = {
    height: "10vh",
    width: "100%",
  };
  return (
    <div className="map-location">
      <div className="restaurant-name">
        <p>{restaurantId !== null ? restaurantCart?.restaurant?.nom : ""}</p>
      </div>
      <div className="location-adresse">
        <p>
          {restaurantId !== null ? restaurantCart?.restaurant?.address : ""}
        </p>
      </div>
      <div className="map-convas">
        <div className="map">
          <GoogleMap
            options={{
              disableDefaultUI: true, // Disable default UI controls
              draggable: false, // Disable dragging
              clickableIcons: false, // Disable clickable icons
            }}
            mapContainerStyle={GoogleMapStyle}
            zoom={15}
            center={center}
          >
            {showMarker && <Marker opacity={1} position={center} />}
          </GoogleMap>
        </div>
        <div className="location-details">
          <div className="distance">
            {/* <img src={DistanceIcon} alt="" /> */}
            <img src={StarFIDIcon} alt="" />
            <div>
              <p>Points FID</p>
              <p>{userLoyalityPoints}</p>
            </div>
          </div>
          <div className="delivery-type">
            <p className="label">
              {isMaintenantChecked ? "Planifier" : "Maintenant"}
            </p>
            <p>
              <b>
                {getOrderTypeText(restaurantCart?.mode || 0)}
                {restaurantCart?.restaurant?.tempsPrep > 0  && (
                    <b>, prête dans : {tempsPreparation} min</b>
                  )}
              </b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};


export default RestaurantInfo;
